<template>
  <div class="custom-radio">
    <input
      v-bind:disabled="disabled"
      type="radio"
      v-bind:name="name"
      v-bind:class="className"
      v-bind:id="id"
      v-bind:checked="checked"
      v-bind:value="value"
      v-bind:required="required"
      v-on:change="updateInput"
    />
    <label v-bind:for="id">{{ label }}</label>
  </div>
</template>
<script>
export default {
  name: "AppRadio",
  props: {
    name: {
      type: String,
      required: false,
    },
    disabled: {
      type: Boolean,
      required: false,
    },
    className: {
      type: String,
      required: false,
    },
    id: {
      type: String,
      required: false,
    },
    value: {
      type: String,
      required: false,
    },
    required: {
      type: Boolean,
      required: false,
      default: false,
    },
    checked: {
      type: Boolean,
      required: false,
      default: false,
    },
    label: {
      type: String,
      required: true,
    },
    inverted: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  methods: {
    updateInput: function (event) {
      this.$emit("change", `${event.target.value}`);
    },
  },
};
</script>

<style lang="scss">
.custom-radio {
  display: flex;
  align-items: center !important;

  input[type="radio"],
  label {
    user-select: none;
    vertical-align: middle;
    display: flex;
    align-items: center;
  }
  input {
    display: none;
  }

  input[type="checkbox"],
  input[type="radio"] {
    -webkit-appearance: none;
    -webkit-border-radius: 0;
    transition: all 0.2s ease;
    // Better Font Rendering
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;

    &:focus {
      outline: 0;
    }

    &:active {
      outline: none;
    }

    &:hover {
      outline: none;
    }
  }

  input[type="radio"] + label {
    font-size: 18px;
    cursor: pointer;
    padding-right: 30px;
    position: relative;
    display: flex;
    align-items: center;
  }

  input[type="radio"]:checked + label {
    font-weight: bolder;
  }

  input[type="radio"] + label:before {
    content: "";
    top: 2px;
    right: 0;
    bottom: 0;
    width: 22px;
    height: 22px;
    position: absolute;
    background: #7c4dff;
    border-radius: 100%;
    transition: all 0.1s ease;
    box-shadow: inset 0 0 0 18px #fff;
    border: 2px solid #7c4dff;
    display: flex;
    align-items: center;
    margin: 0;
    padding: 0;
  }

  input[type="radio"]:checked + label:before {
    border: 1px solid var(--teal-accent-3);
    box-shadow: inset 0 0 0 4px #fff;
  }

  // an `inverted` class is there for making simple alternative styles
  &.inverted {
    input[type="checkbox"],
    input[type="radio"] {
      border: 1px solid #fff;

      &:focus {
        border: 1px solid darken(#fff, 5%);
      }

      &:checked {
        background: #fff;
      }
    }
  }
}

@media only screen and (max-width: 1024px) {
  .custom-radio {
    input[type="radio"] + label {
      font-size: 16px;
    }
  }
}
+ input[type="checkbox"]:checked {
  background-color: #a77e2d !important;
  color: #ffffff !important;
}
input[type="checkbox"]:after {
  box-shadow: none !important;
}
</style>
